<template>
  <div class="my-4" v-if="treatments.length || loading">
    <h4 class="fw700 gray900 font24 mb-3">{{ title }}</h4>
    <div v-if="loading" class="d-flex justify-content-center my-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>
    <div v-else class="medContainer">
      <div class="p-2 br6 d-flex align-items-center fw700 font14 gray800 cp gap16" v-for="med in treatments" :key="med.id" @click="handleTreatmentClick(med, type)">
        <div class="imgBox">
          <!-- <img v-if="med.url" :src="med.url" class="medImg" alt="image" /> -->
          <img v-if="med.url" :src="med.resized_images ? med.resized_images.dov640x320 : med.url" class="medImg" alt="image" />
          <img v-else :src="getMedImg" class="medImg" alt="image" />
        </div>
        {{ med.display_name }}
        <font-awesome-icon :icon="['far', 'arrow-right']" :style="{ color: getPrimaryColor() }" class="font20 ml-auto" />
      </div>
    </div>
    <div
      v-if="treatments.length > 3"
      :class="`mt-3 p-2 br8 bg-gray100 fw700 font14 text-center cp lh24 ${treatments.length > 3 && treatments.length < 6 ? 'show-in-mobile' : ''}`"
      :style="{ color: getPrimaryColor() }"
      @click="handleTypeClick(type)"
    >
      View more {{ pluralTitle }}
      <font-awesome-icon :icon="['far', 'arrow-right']" :style="{ color: getPrimaryColor() }" class="font14 ml-2" />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const AppRepository = RepositoryFactory.get("app")

export default {
  name: "TreatmentsGroup",
  props: {
    title: String,
    handleTreatmentClick: Function,
    handleTypeClick: Function,
    type: String,
    searchWord: String,
    handleAllEmpty: Function,
  },
  created() {
    this.searchMeds()
  },
  data() {
    return {
      treatments: [],
      loading: false,
    }
  },
  computed: {
    pluralTitle() {
      switch (this.title.toLowerCase()) {
        case "activity":
        case "activitys":
        case "activities":
          return "Activities"
        case "procedure":
        case "procedures":
          return "Procedures"
        case "nonmedicaltreatment":
        case "nonmedicaltreatments":
        case "therapy":
        case "therapys":
        case "therapies":
        case "complimentary therapy":
        case "complimentary therapys":
        case "complimentary therapies":
          return "Complimentary Therapies"
        case "other":
        case "others":
        case "medication":
        case "medications":
          return "Medications"
        case "nutritions & diets":
        case "nutritions & diet":
        case "nutrition & diets":
        case "nutrition & diet":
          return "Nutritions & Diets"
        default:
          return "Treatments"
      }
    },
    getMedImg() {
      switch (this.title.toLowerCase()) {
        case "activity":
        case "activitys":
        case "activities":
          return require(`../../../assets/images/activity.png`)
        case "procedure":
        case "procedures":
          return require("../../../assets/images/procedure.png")
        case "nonmedicaltreatment":
        case "nonmedicaltreatments":
        case "therapy":
        case "therapys":
        case "therapies":
        case "complimentary therapy":
        case "complimentary therapys":
        case "complimentary therapies":
        case "complementary therapy":
        case "complementary therapys":
        case "complementary therapies":
          return require("../../../assets/images/complementary.png")
        case "other":
        case "others":
        case "medication":
        case "medications":
          return require("../../../assets/images/medication.png")
        case "nutritions & diets":
        case "nutritions & diet":
        case "nutrition & diets":
        case "nutrition & diet":
          return require("../../../assets/images/nutrition.png")
        default:
          return require("../../../assets/images/default-treatment-thumbnail.png")
      }
    },
  },
  methods: {
    searchMeds(val = "") {
      switch (this.type) {
        case "nonmedicaltreatments":
          this.loading = true
          AppRepository.searchNonmedicaltreatments(val, this.currentCircle.id, null, 1, 6)
            .then(res => {
              // this.treatments = res.data.data.map(ele => {
              //   ele.display_name = ele.display_name.toLowerCase()
              //   return ele
              // })
              this.treatments = res.data.data
              this.loading = false
              if (!this.treatments.length) {
                this.handleAllEmpty(this.type, true)
              } else {
                this.handleAllEmpty(this.type, false)
              }
            })
            .catch(err => {
              this.loading = false
            })
          break
        default:
          this.loading = true
          AppRepository.searchTreatments(val, this.currentCircle.id, this.type, 1, 6)
            .then(res => {
              if (this.type === "others") {
                // this.treatments = res.data.data
                //   ? res.data.data.extra_treatments.map(ele => {
                //       ele.display_name = ele.display_name.toLowerCase()
                //       return ele
                //     })
                //   : []
                this.treatments = res.data.data ? res.data.data.extra_treatments : []
              } else {
                // this.treatments = res.data.data.circle_treatments.map(ele => {
                //   ele.display_name = ele.display_name.toLowerCase()
                //   return ele
                // })
                this.treatments = res.data.data.circle_treatments
              }
              this.loading = false
              if (!this.treatments.length) {
                this.handleAllEmpty(this.type, true)
              } else {
                this.handleAllEmpty(this.type, false)
              }
            })
            .catch(err => {
              this.loading = false
            })
      }
    },
  },
  watch: {
    searchWord(v) {
      this.searchMeds(v)
    },
  },
}
</script>

<style lang="scss" scoped>
.medContainer {
  display: grid;
  gap: 16px 24px;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    .p-2:nth-child(n + 4) {
      display: none !important;
    }
    // .p-2:nth-last-child(-n + 3) {
    //   display: none !important;
    // }
  }
}
.medImg {
  // max-height: 50px;
  height: 50px;
  margin: auto;
  width: 100%;
  // max-width: 100%;
  object-fit: cover;
}
.emptySpace,
.imgBox {
  height: 50px;
  min-width: 85px;
  max-width: 85px;
  display: flex;
}
.gap16 {
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  &:hover {
    background: #e2e8f0 !important;
  }
}
.bg-gray100 {
  &:hover {
    background: #e2e8f0 !important;
  }
}
@media screen and (max-width: 600px) {
  .my-4 {
    margin: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/treatments/TreatmentsGroup.vue